import React, { useContext } from 'react';

import { HeaderContext } from '../HeaderContext';

import { Wallet as WalletIcon } from '../../Icons';
import { Input } from '../../FormElements/Input';
import { Button, LinkButton } from '@husslehq/ui-library';

import styles from './Wallet.module.scss';

export type WalletProps = {
  action: string;
  referralUrl: string;
};

export const Wallet: React.FC<WalletProps> = ({ action, referralUrl }) => {
  const { walletAmount } = useContext(HeaderContext);
  return (
    <div className={styles.wallet}>
      <h5 className={styles['wallet__title']}>Your Wallet</h5>
      <div className={styles['wallet__balance']}>
        Your balance:{' '}
        <span className={styles['wallet__icon']}>
          <WalletIcon />
        </span>{' '}
        &pound;{walletAmount}
      </div>
      <div className={styles['wallet__redeem']}>
        <form id="voucher-form" className={styles['wallet__form']} action={action}>
          <Input
            labelHidden={false}
            type="text"
            placeholder="Enter your voucher code"
            name="s_voucher_code"
            label="Redeem voucher"
          />
          <Button type="submit" level="primary" size="medium" fullWidth>
            Redeem voucher
          </Button>
        </form>
      </div>
      <p className={styles['wallet__sub-title']}>Gym for free</p>
      <p className={styles['wallet__invite-desc']}>Earn free workouts with Hussle simply by inviting your friends.</p>
      <LinkButton href={referralUrl} fullWidth level="primary" size="medium">
        Invite your friends
      </LinkButton>
    </div>
  );
};
